import { useEffect, useState } from 'react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useQuery } from '@redwoodjs/web';

import { GET_SAGE_TOKEN_STATUS } from 'src/graphql/queries/getSageTokenStatus';
import { useSageAuth } from 'src/hooks/useSageAuth';

import { ConfirmationModal } from '../Modals';

dayjs.extend(utc);

interface SageSystemUserModalProps {
    isOpen;
    onClose;
}

const SageSystemUserModal = ({ isOpen, onClose }: SageSystemUserModalProps) => {
    const { handleSageLogin } = useSageAuth();
    const { data, loading } = useQuery(GET_SAGE_TOKEN_STATUS);

    const [message, setMessage] = useState('Do you want to initialise the buddy Sage system user?');

    useEffect(() => {
        if (!loading) {
            const now = dayjs().utc();

            if (data?.getSageTokenStatus) {
                const { accessTokenExpires, refreshTokenExpires } = data.getSageTokenStatus;
                if (
                    dayjs(accessTokenExpires).isAfter(now) &&
                    dayjs(refreshTokenExpires).isAfter(now)
                ) {
                    setMessage('Do you want to re-initialise the buddy Sage system user?');
                }
            }
        }
    }, [loading, data]);

    const handleConfirm = () => {
        handleSageLogin();
        onClose();
    };

    return (
        <ConfirmationModal
            isOpen={isOpen}
            title="Sage System User"
            message={message}
            onCancel={onClose}
            onConfirm={handleConfirm}
            confirmText="Yes"
            cancelText="No"
        />
    );
};
export default SageSystemUserModal;
